import "../style.scss";
import header from "../../../assets/images/logo_one.svg";
import footerImage from "../../../assets/images/footer_img.svg";
import backgroundImage from "../../../assets/images/Login .png";
import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import useCustomToast from "../../../hooks/useCustomToast";
import UserService from "../../../services/user.service";
import { Toaster } from "react-hot-toast";

function ChangePassword() {
    const params = useParams()
    const customToast = useCustomToast()
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        password: '',
        confirm_password: '',
    });


    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    useEffect(() => {
        if (!params?.token) {
            navigate("/login")
            return
        }
    }, [])

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const { password, confirm_password } = formData;
        if (!params?.token) {
            navigate("/login")
            return
        }
        if (password?.trim() !== confirm_password?.trim()) return customToast("Password did not match", "error")
        const response: any = await UserService.changePassword({ password }, params?.token)
        if (response?.success) {
            customToast(response?.success, "success")
            setTimeout(() => {
                navigate("/login")
            }, 2000)
        }
    };

    return (
        <div className="auth__page">
            <Toaster />
            <div className="row h-100">
                <div className="col-lg-4 col-md-12 p-0">
                    <div className="left">
                        <img src={header} className="login_logo" alt="Pilot Book" />
                        <form>
                            <h2 className="welcome heading2">Change Password</h2>
                            <h4 className="login_subheading heading4">
                                Enter your new password                            </h4>
                            <input
                                className="input"
                                type="text"
                                placeholder="Enter new password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />
                            <h4 className="login_subheading heading4">
                                Confirm Password                          </h4>
                            <input
                                className="input"
                                type="text"
                                placeholder="Confirm Password"
                                name="confirm_password"
                                value={formData.confirm_password}
                                onChange={handleChange}
                                required
                            />
                            <button className="login_btn" onClick={handleSubmit}>Change Password</button>
                        </form>
                        <h4 className="signup_now heading4">
                            <Link to="/login">
                                <span style={{ textDecoration: "underline", color: "#232629" }}>
                                    Login
                                </span>
                            </Link>
                        </h4>
                        <img src={footerImage} className="footer_img" alt="LandScape" />
                        <h4 className="copyright heading4">© 2023 Pilots Logbook</h4>
                    </div>
                </div>
                <div className="col-lg-8 d-none d-md-block h-auto p-0">
                    <div className="background">
                        <img src={backgroundImage} className="login_bg" alt="Login Background" />
                        <div className="content">
                            <h4 className="login_bg_heading">
                                The most complete digital pilot logbook
                            </h4>
                            <h4 className="login_bg_subheading">
                                Pilots Logbook makes your life easier through its super fast flight
                                logging, detailed analysis of your flight time with the Analyze view,
                                the powerful InSight technology that monitors all your upcoming flights
                                and warns you of any rest / duty / currency issues, with all your
                                irreplaceable flying life backed up to your choice of iCloud, Dropbox,
                                or both!
                            </h4>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default ChangePassword;